// extracted by mini-css-extract-plugin
export var radio = "RadioBtn-module--radio--b7457";
export var checkmark = "RadioBtn-module--checkmark--cd99e";
export var input = "RadioBtn-module--input--64205";
export var name = "RadioBtn-module--name--27b83";